import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { IonList, IonItem, IonNote, IonLabel } from '@ionic/react';
import { VenueLogo } from 'components/venue';
import { ReceiptSelectors } from 'redux/ReceiptRedux';
import { AppSelectors } from 'redux/AppRedux';
import _orderBy from 'lodash/orderBy';
import { formatCurrency } from 'utils/currency';

function ReceiptList() {
  const history = useHistory();
  const receipts = useSelector(ReceiptSelectors.selectReceipts);
  const venues = useSelector(AppSelectors.selectVenues);

  const filterReceipts = useMemo(() => {
    return _orderBy(
      receipts.filter((t) => !t.checks.find((c) => c.status !== 'paid')),
      'updatedAt',
      'desc'
    );
  }, [receipts]);

  return (
    <IonList>
      {filterReceipts.map((r) => {
        const venue = venues.find((v) => v.id === r.venueId) || {
          name: r.venueName,
        };

        return (
          <IonItem
            key={r._id}
            lines="none"
            button
            onClick={() => history.push(`/receipts/${r._id}`)}
          >
            <VenueLogo logo={venue.logo} />
            <IonLabel>
              <h2>{venue.name}</h2>
              <p>{moment(r.updatedAt).format('MMM D, YYYY hh:mm A')}</p>
            </IonLabel>
            <IonNote slot="end">
              {formatCurrency(r.totals.paid + r.totals.tips)}
            </IonNote>
          </IonItem>
        );
      })}
    </IonList>
  );
}

export default ReceiptList;
